import store from '@/state/store'

export default [{
    path: '/login',
    name: 'login',
    component: () => import('../views/pages/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['authapi/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'home'
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot-password',
    component: () => import('../views/pages/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['authapi/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'home'
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
          store.dispatch('authfack/logout')
        }else if (process.env.VUE_APP_DEFAULT_AUTH === "api") {
          store.dispatch('authapi/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? {
          name: 'home'
        } : {
          ...routeFrom
        })
      },
    },
  }, 
  {
    path: '/',
    name: 'home',
    meta: {
      authRequired: true,
    },
    component: () => import('../views/pages/dashboard/index')
  },
  {
    path: '/customers',
    name: 'customers',
    meta: {
      authRequired: true,
      access: "customers"
    },
    component: () => import('../views/pages/customers/index')
  },
  {
    path: '/customers/profile/:id',
    name: 'customers_profile',
    meta: {
      authRequired: true,
      access: "customers"
    },
    component: () => import('../views/pages/customers/profile'),
    props: true
  },
  {
    path: '/teams/list',
    name: 'teams_list',
    meta: {
      authRequired: true,
      access: "teams"
    },
    component: () => import('../views/pages/teams/list'),
    props: true
  },
  {
    path: '/teams/squad',
    name: 'teams_squad',
    meta: {
      authRequired: true,
      access: "teams"
    },
    component: () => import('../views/pages/teams/squad'),
    props: true
  },
  {
    path: '/fixtures/featured_matches',
    name: 'fixtures_featured_matches',
    meta: {
      authRequired: true,
      access: "fixtures"
    },
    component: () => import('../views/pages/fixtures/featured_matches'),
    props: true
  },
  {
    path: '/fixtures/rounds',
    name: 'fixtures_rounds',
    meta: {
      authRequired: true,
      access: "fixtures"
    },
    component: () => import('../views/pages/fixtures/rounds'),
    props: true
  },
  {
    path: '/fixtures/standings',
    name: 'fixtures_standings',
    meta: {
      authRequired: true,
      access: "fixtures"
    },
    component: () => import('../views/pages/fixtures/standings'),
    props: true
  },
  {
    path: '/advertising/banner',
    name: 'advertising_banner',
    meta: {
      authRequired: true,
      access: "advertising"
    },
    component: () => import('../views/pages/advertising/banner'),
    props: true
  },
  {
    path: '/advertising/advertorial',
    name: 'advertising_advertorial',
    meta: {
      authRequired: true,
      access: "advertising"
    },
    component: () => import('../views/pages/advertising/advertorial'),
    props: true
  },
  {
    path: '/advertising/sponsors',
    name: 'advertising_sponsors',
    meta: {
      authRequired: true,
      access: "advertising"
    },
    component: () => import('../views/pages/advertising/sponsors'),
    props: true
  },
  {
    path: '/advertising/sponsor/:id',
    name: 'advertising_sponsor',
    meta: {
      authRequired: true,
      access: "advertising"
    },
    component: () => import('../views/pages/advertising/sponsor'),
    props: true
  },
  {
    path: '/advertising/player',
    name: 'advertising_player',
    meta: {
      authRequired: true,
      access: "advertising"
    },
    component: () => import('../views/pages/advertising/player'),
    props: true
  },
  {
    path: '/advertising/wall',
    name: 'advertising_wall',
    meta: {
      authRequired: true,
      access: "advertising"
    },
    component: () => import('../views/pages/advertising/wall'),
    props: true
  },
  {
    path: '/rss/news',
    name: 'rss_news',
    meta: {
      authRequired: true,
      access: "rss"
    },
    component: () => import('../views/pages/rss/news'),
    props: true
  },
  {
    path: '/games/man_of_the_match',
    name: 'man_of_the_match',
    meta: {
      authRequired: true,
      access: "games"
    },
    component: () => import('../views/pages/games/man_of_the_match'),
    props: true
  },
  {
    path: '/games/guess_the_score',
    name: 'guess_the_score',
    meta: {
      authRequired: true,
      access: "games"
    },
    component: () => import('../views/pages/games/guess_the_score'),
    props: true
  },
  {
    path: '*',
    name: 'not_found',
    meta: {
      authRequired: true,
    },
    component: () => import('../views/pages/utility/404')
  },
  {
    path: '/notifications',
    name: 'notif',
    meta: {
      authRequired: true,
      access: "notifications"
    },
    component: () => import('../views/pages/notifications/index')
  },
  {
    path: '/notifications/details',
    name: 'notif_details',
    meta: {
      authRequired: true,
      access: "notifications"
    },
    component: () => import('../views/pages/notifications/details')
  },
  {
    path: '/monitor/queues',
    name: 'monitor_queues',
    meta: {
      authRequired: true,
      access: "monitor"
    },
    component: () => import('../views/pages/monitor/queues')
  },
  {
    path: '/monitor/queues/:id',
    name: 'monitor_queue_detail',
    meta: {
      authRequired: true,
      access: "monitor"
    },
    component: () => import('../views/pages/monitor/queue_details'),
    props: true
  },
  {
    path: '/orders',
    name: 'Orders',
    meta: {
      authRequired: true,
      access: "orders"
    },
    component: () => import('../views/pages/orders/index')
  },






  {
    path: '/calendar',
    name: 'calendar',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/calendar/index')
  },
  {
    path: '/chat',
    name: 'chat',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/chat/index')
  },
  {
    path: '/ecommerce/products',
    name: 'Products',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ecommerce/products')
  },
  {
    path: '/ecommerce/product-detail/:id',
    name: 'Product Detail',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ecommerce/product-detail')
  },
  {
    path: '/ecommerce/orders',
    name: 'Ecomerce Orders',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ecommerce/orders')
  },
  {
    path: '/ecommerce/customers',
    name: 'Customers',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ecommerce/customers')
  },
  {
    path: '/ecommerce/cart',
    name: 'Cart',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ecommerce/cart')
  },
  {
    path: '/ecommerce/checkout',
    name: 'Checkout',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ecommerce/checkout')
  },
  {
    path: '/ecommerce/shops',
    name: 'Shops',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ecommerce/shops')
  },
  {
    path: '/ecommerce/add-product',
    name: 'Add Product',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ecommerce/add-product')
  },
  {
    path: '/email/inbox',
    name: 'Inbox',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/email/inbox')
  },
  {
    path: '/email/reademail/:id',
    name: 'Read Email',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/email/reademail')
  },
  {
    path: '/invoices/detail',
    name: 'Invoice Detail',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/invoices/detail')
  },
  {
    path: '/invoices/list',
    name: 'Invoice List',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/invoices/list')
  },
  {
    path: '/contacts/grid',
    name: 'User Grid',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/contacts/grid')
  },
  {
    path: '/contacts/profile',
    name: 'Profile',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/contacts/profile')
  },
  {
    path: '/utility/starter',
    name: 'Starter-page',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/utility/starter')
  },
  {
    path: '/utility/maintenance',
    name: 'maintenance',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/utility/maintenance')
  },
  {
    path: '/utility/comingsoon',
    name: 'comingsoon',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/utility/comingsoon')
  },
  {
    path: '/utility/timeline',
    name: 'timeline',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/utility/timeline')
  },
  {
    path: '/utility/faqs',
    name: 'faqs',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/utility/faqs')
  },
  {
    path: '/utility/pricing',
    name: 'pricing',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/utility/pricing')
  },
  {
    path: '/utility/404',
    name: 'error-404',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/utility/404')
  },
  {
    path: '/utility/500',
    name: 'error-500',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/utility/500')
  },
  {
    path: '/form/elements',
    name: 'elements',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/form/elements')
  },
  {
    path: '/form/validation',
    name: 'validation',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/form/validation')
  },
  {
    path: '/form/advanced',
    name: 'form-advanced',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/form/advanced')
  },
  {
    path: '/form/editor',
    name: 'editor',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/form/editor')
  },
  {
    path: '/form/upload',
    name: 'upload',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/form/upload')
  },
  {
    path: '/form/repeater',
    name: 'repeater',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/form/repeater')
  },
  {
    path: '/form/wizard',
    name: 'wizard',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/form/wizard')
  },
  {
    path: '/form/mask',
    name: 'mask',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/form/mask')
  },
  {
    path: '/tables/basic',
    name: 'basic-table',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/tables/basic')
  },
  {
    path: '/tables/advanced',
    name: 'advanced',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/tables/advanced')
  },
  {
    path: '/charts/apex',
    name: 'apex',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/charts/apex/index')
  },
  {
    path: '/charts/chartist',
    name: 'chartist',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/charts/chartist/index')
  },
  {
    path: '/charts/chartjs',
    name: 'chartjs',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/charts/chartjs/index')
  },
  {
    path: '/charts/echart',
    name: 'echart',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/charts/echart/index')
  },
  {
    path: '/icons/unicons',
    name: 'unicons',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/icons/unicons')
  },
  {
    path: '/icons/boxicons',
    name: 'boxicons',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/icons/boxicons')
  },
  {
    path: '/icons/materialdesign',
    name: 'materialdesign',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/icons/materialdesign')
  },
  {
    path: '/icons/dripicons',
    name: 'dripicons',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/icons/dripicons')
  },
  {
    path: '/icons/fontawesome',
    name: 'fontawesome',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/icons/fontawesome')
  },
  {
    path: '/maps/google',
    name: 'google',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/maps/google')
  },
  {
    path: '/maps/leaflet',
    name: 'leaflet',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/maps/leaflet')
  },
  {
    path: '/ui/alerts',
    name: 'alerts',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/alerts')
  },
  {
    path: '/ui/buttons',
    name: 'buttons',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/buttons')
  },
  {
    path: '/ui/cards',
    name: 'cards',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/cards')
  }, {
    path: '/ui/carousel',
    name: 'carousel',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/carousel')
  }, {
    path: '/ui/dropdown',
    name: 'dropdown',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/dropdown')
  }, {
    path: '/ui/grid',
    name: 'grid',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/grid')
  }, {
    path: '/ui/images',
    name: 'images',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/images')
  }, {
    path: '/ui/lightbox',
    name: 'lightbox',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/lightbox')
  },
  {
    path: '/ui/modals',
    name: 'modals',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/modals')
  },
  {
    path: '/ui/rangeslider',
    name: 'rangeslider',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/rangeslider')
  },
  {
    path: '/ui/progressbar',
    name: 'progressbar',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/progressbar')
  },
  {
    path: '/ui/placeholder',
    name: 'placeholder',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/placeholder')
  },
  {
    path: '/ui/sweet-alert',
    name: 'sweet-alert',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/sweet-alert')
  },

  {
    path: '/ui/tabs-accordions',
    name: 'tabs-accordions',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/tabs-accordions')
  },
  {
    path: '/ui/typography',
    name: 'typography',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/typography')
  },

  {
    path: '/ui/video',
    name: 'video',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/video')
  },
  {
    path: '/ui/general',
    name: 'general',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/general')
  },
  {
    path: '/ui/colors',
    name: 'colors',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/colors')
  },
  {
    path: '/ui/rating',
    name: 'rating',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/ui/rating')
  },
  {
    path: '/auth/login-1',
    name: 'login-1',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/auth/login-1')
  },
  {
    path: '/auth/register-1',
    name: 'register-1',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/auth/register-1')
  },{
    path: '/auth/lock-screen',
    name: 'lock-screen',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/auth/lock-screen')
  },
  {
    path: '/auth/recoverpwd',
    name: 'recoverpwd',
    meta: {
      authRequired: true,
      access: "template"
    },
    component: () => import('../views/pages/auth/recoverpwd')
  },
  


]